module.exports = __webpack_public_path__ + "img/permission.022f1468.svg";